import React, { useState, useEffect } from "react";
import {
  getSenateCandidates,
  getExecutiveCandidates,
} from "../../Sevices/api-requests";

const CandidateList = () => {
  const [executive, setExecutive] = useState([]);
  const [senate, setSenate] = useState([]);

  useEffect(() => {
    getCandidates();
  }, []);

  const getCandidates = async () => {
    await getExecutiveCandidates("Sports Secretary").then((result) => {
      setExecutive(result.data.data);
    });
    await getSenateCandidates(700).then((result) => {
      setSenate(result.data.data);
    });
  };
  return <div>List of candidates</div>;
};

export default CandidateList;
